import { render, staticRenderFns } from "./Teacher.vue?vue&type=template&id=46b0b2c8&scoped=true"
import script from "./Teacher.vue?vue&type=script&lang=js"
export * from "./Teacher.vue?vue&type=script&lang=js"
import style0 from "./Teacher.vue?vue&type=style&index=0&id=46b0b2c8&prod&lang=scss&scoped=true"
import style1 from "./Teacher.vue?vue&type=style&index=1&id=46b0b2c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b0b2c8",
  null
  
)

export default component.exports